import { useEffect, useState, useCallback } from "react";
import { api, apiError } from "../../lib/api";
import { PageHeader } from "../../components/Layout";
import { Button } from "../../components/ui/button";
import { Card } from "../../components/ui/card";
import { Bell, BellRinging, CheckCircle } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function PartnerNotifications() {
  const [rows, setRows] = useState([]);

  const load = useCallback(() => { api.get("/partner/notifications").then((r) => setRows(r.data)); }, []);
  useEffect(() => { load(); }, [load]);

  const markAll = async () => {
    try {
      await api.post("/partner/notifications/read-all");
      toast.success("All marked as read");
      load();
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };

  const unread = rows.filter((n) => !n.read).length;

  return (
    <>
      <PageHeader title="Notifications" subtitle={`${unread} unread`}
        actions={unread > 0 && <Button variant="outline" className="rounded-sm gap-2" onClick={markAll} data-testid="mark-all-read"><CheckCircle size={16} /> Mark all read</Button>} />
      <div className="p-8 space-y-3 max-w-3xl" data-testid="notifications-list">
        {rows.length === 0 && <p className="text-sm text-muted-foreground">No notifications.</p>}
        {rows.map((n) => (
          <Card key={n.id} className={`rounded-sm p-4 border-border flex items-start gap-3 ${n.read ? "" : "bg-blue-50/60 border-blue-200"}`} data-testid={`notif-${n.id}`}>
            <div className={`w-9 h-9 rounded-sm flex items-center justify-center shrink-0 ${n.type === "reminder" ? "bg-amber-100 text-amber-700" : "bg-blue-100 text-blue-700"}`}>
              {n.type === "reminder" ? <BellRinging size={18} weight="bold" /> : <Bell size={18} weight="bold" />}
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between">
                <p className="font-semibold">{n.title}</p>
                {!n.read && <span className="w-2 h-2 rounded-full bg-blue-600" />}
              </div>
              <p className="text-sm text-muted-foreground mt-0.5">{n.message}</p>
              <p className="text-xs text-muted-foreground mt-1">{new Date(n.created_at).toLocaleString("en-IN")}</p>
            </div>
          </Card>
        ))}
      </div>
    </>
  );
}
